module.exports = __webpack_public_path__ + "img/pic_company_logo_S.e10f5c07.png";